"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRIDGE_ADAPTER_DATA = exports.CONTRACT_ADDRESSES = exports.DEFAULT_L2_CONTRACT_ADDRESSES = exports.CHAIN_BLOCK_TIMES = exports.DEPOSIT_CONFIRMATION_BLOCKS = void 0;
const contracts_1 = require("@eth-optimism/contracts");
const contracts_bedrock_1 = require("@eth-optimism/contracts-bedrock");
const OptimismPortalProxy_json_1 = __importDefault(require("@eth-optimism/contracts-bedrock/deployments/mainnet/OptimismPortalProxy.json"));
const OptimismPortalProxy_json_2 = __importDefault(require("@eth-optimism/contracts-bedrock/deployments/goerli/OptimismPortalProxy.json"));
const L2OutputOracleProxy_json_1 = __importDefault(require("@eth-optimism/contracts-bedrock/deployments/mainnet/L2OutputOracleProxy.json"));
const L2OutputOracleProxy_json_2 = __importDefault(require("@eth-optimism/contracts-bedrock/deployments/goerli/L2OutputOracleProxy.json"));
const portalAddresses = {
    mainnet: OptimismPortalProxy_json_1.default,
    goerli: OptimismPortalProxy_json_2.default,
};
const l2OutputOracleAddresses = {
    mainnet: L2OutputOracleProxy_json_1.default,
    goerli: L2OutputOracleProxy_json_2.default,
};
const interfaces_1 = require("../interfaces");
const adapters_1 = require("../adapters");
exports.DEPOSIT_CONFIRMATION_BLOCKS = {
    [interfaces_1.L2ChainID.OPTIMISM]: 50,
    [interfaces_1.L2ChainID.OPTIMISM_GOERLI]: 12,
    [interfaces_1.L2ChainID.OPTIMISM_HARDHAT_LOCAL]: 2,
    [interfaces_1.L2ChainID.OPTIMISM_HARDHAT_DEVNET]: 2,
    [interfaces_1.L2ChainID.OPTIMISM_BEDROCK_LOCAL_DEVNET]: 2,
    [interfaces_1.L2ChainID.OPTIMISM_BEDROCK_ALPHA_TESTNET]: 12,
    [interfaces_1.L2ChainID.BASE_GOERLI]: 12,
};
exports.CHAIN_BLOCK_TIMES = {
    [interfaces_1.L1ChainID.MAINNET]: 13,
    [interfaces_1.L1ChainID.GOERLI]: 15,
    [interfaces_1.L1ChainID.HARDHAT_LOCAL]: 1,
    [interfaces_1.L1ChainID.BEDROCK_LOCAL_DEVNET]: 15,
};
exports.DEFAULT_L2_CONTRACT_ADDRESSES = {
    L2CrossDomainMessenger: contracts_1.predeploys.L2CrossDomainMessenger,
    L2ToL1MessagePasser: contracts_1.predeploys.OVM_L2ToL1MessagePasser,
    L2StandardBridge: contracts_1.predeploys.L2StandardBridge,
    OVM_L1BlockNumber: contracts_1.predeploys.OVM_L1BlockNumber,
    OVM_L2ToL1MessagePasser: contracts_1.predeploys.OVM_L2ToL1MessagePasser,
    OVM_DeployerWhitelist: contracts_1.predeploys.OVM_DeployerWhitelist,
    OVM_ETH: contracts_1.predeploys.OVM_ETH,
    OVM_GasPriceOracle: contracts_1.predeploys.OVM_GasPriceOracle,
    OVM_SequencerFeeVault: contracts_1.predeploys.OVM_SequencerFeeVault,
    WETH: contracts_1.predeploys.WETH9,
    BedrockMessagePasser: contracts_bedrock_1.predeploys.L2ToL1MessagePasser,
};
const getL1ContractsByNetworkName = (network) => {
    const getDeployedAddress = (name) => {
        return (0, contracts_1.getDeployedContractDefinition)(name, network).address;
    };
    return {
        AddressManager: getDeployedAddress('Lib_AddressManager'),
        L1CrossDomainMessenger: getDeployedAddress('Proxy__OVM_L1CrossDomainMessenger'),
        L1StandardBridge: getDeployedAddress('Proxy__OVM_L1StandardBridge'),
        StateCommitmentChain: getDeployedAddress('StateCommitmentChain'),
        CanonicalTransactionChain: getDeployedAddress('CanonicalTransactionChain'),
        BondManager: getDeployedAddress('BondManager'),
        OptimismPortal: portalAddresses[network].address,
        L2OutputOracle: l2OutputOracleAddresses[network].address,
    };
};
exports.CONTRACT_ADDRESSES = {
    [interfaces_1.L2ChainID.OPTIMISM]: {
        l1: getL1ContractsByNetworkName('mainnet'),
        l2: exports.DEFAULT_L2_CONTRACT_ADDRESSES,
    },
    [interfaces_1.L2ChainID.OPTIMISM_GOERLI]: {
        l1: getL1ContractsByNetworkName('goerli'),
        l2: exports.DEFAULT_L2_CONTRACT_ADDRESSES,
    },
    [interfaces_1.L2ChainID.OPTIMISM_HARDHAT_LOCAL]: {
        l1: {
            AddressManager: '0x5FbDB2315678afecb367f032d93F642f64180aa3',
            L1CrossDomainMessenger: '0x8A791620dd6260079BF849Dc5567aDC3F2FdC318',
            L1StandardBridge: '0x610178dA211FEF7D417bC0e6FeD39F05609AD788',
            StateCommitmentChain: '0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9',
            CanonicalTransactionChain: '0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9',
            BondManager: '0x5FC8d32690cc91D4c39d9d3abcBD16989F875707',
            OptimismPortal: '0x0000000000000000000000000000000000000000',
            L2OutputOracle: '0x0000000000000000000000000000000000000000',
        },
        l2: exports.DEFAULT_L2_CONTRACT_ADDRESSES,
    },
    [interfaces_1.L2ChainID.OPTIMISM_HARDHAT_DEVNET]: {
        l1: {
            AddressManager: '0x5FbDB2315678afecb367f032d93F642f64180aa3',
            L1CrossDomainMessenger: '0x8A791620dd6260079BF849Dc5567aDC3F2FdC318',
            L1StandardBridge: '0x610178dA211FEF7D417bC0e6FeD39F05609AD788',
            StateCommitmentChain: '0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9',
            CanonicalTransactionChain: '0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9',
            BondManager: '0x5FC8d32690cc91D4c39d9d3abcBD16989F875707',
            OptimismPortal: '0x0000000000000000000000000000000000000000',
            L2OutputOracle: '0x0000000000000000000000000000000000000000',
        },
        l2: exports.DEFAULT_L2_CONTRACT_ADDRESSES,
    },
    [interfaces_1.L2ChainID.OPTIMISM_BEDROCK_LOCAL_DEVNET]: {
        l1: {
            AddressManager: '0x6900000000000000000000000000000000000005',
            L1CrossDomainMessenger: '0x6900000000000000000000000000000000000002',
            L1StandardBridge: '0x6900000000000000000000000000000000000003',
            StateCommitmentChain: '0x0000000000000000000000000000000000000000',
            CanonicalTransactionChain: '0x0000000000000000000000000000000000000000',
            BondManager: '0x0000000000000000000000000000000000000000',
            OptimismPortal: '0x6900000000000000000000000000000000000001',
            L2OutputOracle: '0x6900000000000000000000000000000000000000',
        },
        l2: exports.DEFAULT_L2_CONTRACT_ADDRESSES,
    },
    [interfaces_1.L2ChainID.OPTIMISM_BEDROCK_ALPHA_TESTNET]: {
        l1: {
            AddressManager: '0xb4e08DcE1F323608229265c9d4125E22a4B9dbAF',
            L1CrossDomainMessenger: '0x838a6DC4E37CA45D4Ef05bb776bf05eEf50798De',
            L1StandardBridge: '0xFf94B6C486350aD92561Ba09bad3a59df764Da92',
            StateCommitmentChain: '0x0000000000000000000000000000000000000000',
            CanonicalTransactionChain: '0x0000000000000000000000000000000000000000',
            BondManager: '0x0000000000000000000000000000000000000000',
            OptimismPortal: '0xA581Ca3353DB73115C4625FFC7aDF5dB379434A8',
            L2OutputOracle: '0x3A234299a14De50027eA65dCdf1c0DaC729e04A6',
        },
        l2: exports.DEFAULT_L2_CONTRACT_ADDRESSES,
    },
    [interfaces_1.L2ChainID.BASE_GOERLI]: {
        l1: {
            AddressManager: '0x4Cf6b56b14c6CFcB72A75611080514F94624c54e',
            L1CrossDomainMessenger: '0x8e5693140eA606bcEB98761d9beB1BC87383706D',
            L1StandardBridge: '0xfA6D8Ee5BE770F84FC001D098C4bD604Fe01284a',
            StateCommitmentChain: '0x0000000000000000000000000000000000000000',
            CanonicalTransactionChain: '0x0000000000000000000000000000000000000000',
            BondManager: '0x0000000000000000000000000000000000000000',
            OptimismPortal: '0xe93c8cD0D409341205A592f8c4Ac1A5fe5585cfA',
            L2OutputOracle: '0x2A35891ff30313CcFa6CE88dcf3858bb075A2298',
        },
        l2: exports.DEFAULT_L2_CONTRACT_ADDRESSES,
    },
};
exports.BRIDGE_ADAPTER_DATA = {
    [interfaces_1.L2ChainID.OPTIMISM]: {
        wstETH: {
            Adapter: adapters_1.DAIBridgeAdapter,
            l1Bridge: '0x76943C0D61395d8F2edF9060e1533529cAe05dE6',
            l2Bridge: '0x8E01013243a96601a86eb3153F0d9Fa4fbFb6957',
        },
        BitBTC: {
            Adapter: adapters_1.StandardBridgeAdapter,
            l1Bridge: '0xaBA2c5F108F7E820C049D5Af70B16ac266c8f128',
            l2Bridge: '0x158F513096923fF2d3aab2BcF4478536de6725e2',
        },
        DAI: {
            Adapter: adapters_1.DAIBridgeAdapter,
            l1Bridge: '0x10E6593CDda8c58a1d0f14C5164B376352a55f2F',
            l2Bridge: '0x467194771dAe2967Aef3ECbEDD3Bf9a310C76C65',
        },
    },
    [interfaces_1.L2ChainID.OPTIMISM_GOERLI]: {
        DAI: {
            Adapter: adapters_1.DAIBridgeAdapter,
            l1Bridge: '0x05a388Db09C2D44ec0b00Ee188cD42365c42Df23',
            l2Bridge: '0x467194771dAe2967Aef3ECbEDD3Bf9a310C76C65',
        },
        ECO: {
            Adapter: adapters_1.ECOBridgeAdapter,
            l1Bridge: '0x7a01E277B8fDb8CDB2A2258508514716359f44A0',
            l2Bridge: '0x7a01E277B8fDb8CDB2A2258508514716359f44A0',
        },
    },
};
//# sourceMappingURL=chain-constants.js.map